import * as keyapis_telemetry_status_v1_device_pb from "./v1/keyapis_telemetry_status_device_v1.pb";
import * as keyapis_telemetry_status_v1_system_pb from "./v1/keyapis_telemetry_status_system_v1.pb";

export default {
  v1: {
    resources: {
      device: keyapis_telemetry_status_v1_device_pb,
      system: keyapis_telemetry_status_v1_system_pb,
    },
  },
};
